/* eslint-disable no-magic-numbers */
import React from 'react';
import clsx from 'clsx';

import { useReportBuilderContext } from '../../report-builder.context';
import { useI18nConstants } from '../../use-i18n-constants';

import styles from './zoom-menu.scss';
import { useIntl } from 'react-intl';

interface Props {
  toggleMenu: (open: boolean) => void;
  bottom?: number | string;
  left?: number | string;
}
export const ZoomMenu = ({ toggleMenu, bottom = 'auto', left = 144 }: Props) => {
  const intl = useIntl();
  const {
    pageSetup: { zoom },
    setZoom,
    workAreaWidth,
    getPageWidth
  } = useReportBuilderContext();
  const { zoomOptions } = useI18nConstants();

  const handleClick = (zoomValue: number) => {
    if (zoomValue) {
      setZoom(zoomValue);
    } else {
      if (!workAreaWidth) {
        setZoom(1);
      }
      setZoom(Math.floor((100 * workAreaWidth) / getPageWidth()) / 100);
    }
    toggleMenu(false);
  };

  const isZoomOptionActive = (option: { label: string; value: number }) => {
    if (zoom == option.value) {
      return true;
    }
    if (!option.value && !zoomOptions.find(e => e.value == zoom)) {
      return true;
    }
    return false;
  };

  return (
    <aside aria-label={intl.formatMessage({ id: 'common.zoom_menu.aria_label', defaultMessage: 'Zoom menu' })}>
      <div className={clsx(styles.zoomDropdownContainer)} style={{ bottom, left }}>
        <div className={clsx(styles.separator)}></div>
        {zoomOptions.map(v => (
          <div
            key={v.label}
            className={`${clsx(styles.dropdownItem)} ${isZoomOptionActive(v) ? clsx(styles.active) : ''}`}
            onClick={() => handleClick(v.value)}
          >
            {v.label}
          </div>
        ))}
      </div>
    </aside>
  );
};
